import { defineMessages } from 'react-intl';

export const messages: {
	connectButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	socialProofOrgUsesPercent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connectButton: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.connect-button',
		defaultMessage: 'Connect',
		description: 'Button label to initiate connecting a third-party app',
	},
	connectedLabel: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.connected-label',
		defaultMessage: 'Connected',
		description: 'Label indicating that the user has already connected this third-party app',
	},
	socialProofOrgUsesPercent: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.social-proof.org-uses-percent',
		defaultMessage: '{percent}% of your org connected this app',
		description:
			'Social proof line showing what percentage of the organization has connected this connector. {percent} is the rounded whole number.',
	},
});
